import { createContext } from 'react';

const ContactContext = createContext([]);

export default ContactContext;
